import useAllTitleResults from "./useAllTitleResults.ts";
import useTitleLicenseResults from "./useTitleLicenseResults.ts";
import { combineSearchStatus } from "../types.ts";

export default function useTitleResults() {
  const allResults = useAllTitleResults();
  const licenseResults = useTitleLicenseResults();

  const status = combineSearchStatus(allResults.status, licenseResults.status);

  return {
    status,
    allResults,
    licenseResults,
  };
}
